import React from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import NfdTradeBotsStartSection from "./sections/startSection/NfdTradeBotsStartSection";
import InfoCardsSection from "./sections/infoCardsSection/InfoCardsSection";
import SupportNetworksSection from "./sections/supportNetworksSection/SupportNetworksSection";
import AvailableFunctionalitySection from "./sections/availableFunctionalitySection/AvailableFunctionalitySection";
import StartTradingNowSection from "./sections/startTradingNowSection/StartTradingNowSection";
import FaqTradeSection from "./sections/faqTradeSection/FaqTradeSection";
import MoneyFromReferralsSection from "./sections/moneyFromReferralsSection/MoneyFromReferralsSection";
import JoinOurCommunitySection from "./sections/joinOurCommunitySection/JoinOurCommunitySection";
import AvailableBenefitsSection from "./sections/availableBenefitsSection/AvailableBenefitsSection";

const NfdTradeBots = () => {
	return (
		<div className="nfdTradeBots">
			<Header mode={"dark"} />
			<NfdTradeBotsStartSection />
			<InfoCardsSection />
			<SupportNetworksSection />
			<AvailableFunctionalitySection />
			<MoneyFromReferralsSection />
			<AvailableBenefitsSection />
			<JoinOurCommunitySection />
			<StartTradingNowSection />
			<FaqTradeSection />
			<FooterSection />
		</div>
	);
};

export default NfdTradeBots;